import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.studentMedicalBenefitsTugo.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.studentMedicalBenefitsTugo.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'This section relates to medical expenses such as doctor visits, prescriptions or hospitalizations and similar services.',
  },

  // Checkbox 1: Doctor's Visit
  checkboxDoctorVisit: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxDoctorVisit',
    defaultMessage: "Doctor's Visit",
  },
  questionIsTheDoctorsVisitForAnAnnualPhysicalExam: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionIsTheDoctorsVisitForAnAnnualPhysicalExam',
    defaultMessage: "Is the doctor's visit for an Annual Physical Visit?",
  },
  headerAnnualPhysicalExam: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerAnnualPhysicalExam',
    defaultMessage: 'Annual Physical Visit',
  },
  questionFirstVisitIllnessAccident: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionFirstVisitIllnessAccident',
    defaultMessage: 'Is this visit related to the first instance of an illness or accident?',
  },
  headerOutpatientPhysicianFees: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerOutpatientPhysicianFees',
    defaultMessage: 'Outpatient Physician Fees',
  },
  questionFollowUpVisit: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionFollowUpVisit',
    defaultMessage: 'Is this a follow up visit for a previously claimed illness or accident other than a fracture?',
  },
  questionFollowUpVisitFracture: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionFollowUpVisitFracture',
    defaultMessage: 'Is this a follow up visit for a fracture?',
  },
  headerFollowUpVisit: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerFollowUpVisit',
    defaultMessage: 'Follow Up Visit',
  },
  tooltipFollowUpVisit: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipFollowUpVisit',
    defaultMessage: 'A Follow Up Visit must take place within the 14 days of the initial emergency treatment, and must be required as a direct result of the initial emergency.  We do not pay for continuous care.',
  },
  messageNoOngoingCare: {
    id: 'fastCover.studentMedicalBenefitsTugo.messageNoOngoingCare',
    defaultMessage: 'We do not cover visits for ongoing care. Please refer to your policy document for further detail.',
  },
  questionIsTheDoctorsVisitForSTITestingVaccinationsTBEyeExam: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionIsTheDoctorsVisitForSTITestingVaccinationsTBEyeExam',
    defaultMessage: "Is the doctor's visit for STI testing, vaccinations, TB testing, or an eye exam?",
  },
  headerSTITesting: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerSTITesting',
    defaultMessage: 'Sexually Transmitted Infection Testing',
  },
  headerVaccinationsTBTesting: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerVaccinationsTBTesting',
    defaultMessage: 'Vaccinations and Tuberculosis Testing',
  },
  tooltipVaccinationsTBTesting: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipVaccinationsTBTesting',
    defaultMessage: 'One visit per year per insured. If your policy period is less than 180 days, there is no coverage for this benefit.',
  },
  headerEyeExamination: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerEyeExamination',
    defaultMessage: 'Eye Examination',
  },
  tooltipEyeExamination: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipEyeExamination',
    defaultMessage: 'One visit per year per insured. If your policy period is less than 180 days, there is no coverage for this benefit.',
  },

  // Checkbox 2: Diagnostic Tests
  checkboxDiagnosticTests: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },
  headerDiagnosticTests: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },

  // Checkbox 3: Prescription Drugs
  checkboxPrescriptionDrugs: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugs: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },

  // Checkbox 4: Ambulance Services
  checkboxAmbulanceServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxAmbulanceServices',
    defaultMessage: 'Ambulance Services',
  },
  questionGroundAmbulance: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionGroundAmbulance',
    defaultMessage: 'Is your invoice for a ground ambulance?',
  },
  headerGroundAmbulance: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerGroundAmbulance',
    defaultMessage: 'Ground Ambulance',
  },
  questionAirAmbulance: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionAirAmbulance',
    defaultMessage: 'Is your invoice for an air ambulance?',
  },
  headerAirAmbulance: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerAirAmbulance',
    defaultMessage: 'Air Ambulance',
  },
  otherTypesOfAmbulance: {
    id: 'fastCover.studentMedicalBenefitsTugo.otherTypesOfAmbulance',
    defaultMessage: 'Other Types of Ambulances',
  },

  // Checkbox 5: Hospitalization
  checkboxHospitalization: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxHospitalization',
    defaultMessage: 'Hospitalization',
  },
  questionHospitalInvoice: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionHospitalInvoice',
    defaultMessage: 'Is your invoice from the hospital?',
  },
  headerHospitalFees: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerHospitalFees',
    defaultMessage: 'Hospital Fees',
  },
  questionPhysicianInvoice: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionPhysicianInvoice',
    defaultMessage: 'Is your invoice from the physician?',
  },
  headerInpatientPhysicianFees: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerInpatientPhysicianFees',
    defaultMessage: 'Physician fees while hospitalized',
  },
  questionLabDiagnosticFacility: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionLabDiagnosticFacility',
    defaultMessage: 'Is your invoice from a lab or other diagnostic facility (xrays, bloodwork, etc)?',
  },
  headerXrayLabsOtherDiagnostics: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerXrayLabsOtherDiagnostics',
    defaultMessage: 'X-Ray, Labs, or other diagnostics while hospitalized',
  },
  questionOtherHospitalizationRelated: {
    id: 'fastCover.studentMedicalBenefitsTugo.questionOtherHospitalizationRelated',
    defaultMessage: 'Is your invoice from something else directly related to your hospitalization?',
  },
  headerOtherHospitalizationRelated: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerOtherHospitalizationRelated',
    defaultMessage: 'Other expenses related to hospitalization',
  },
  headerXrayLabsOtherDiagnosticsOther: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerXrayLabsOtherDiagnosticsOther',
    defaultMessage: 'Xray, Labs, or other diagnostics',
  },
  headerMentalHealthPsychiatric: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerMentalHealthPsychiatric',
    defaultMessage: 'Mental health or psychiatric hospitalization',
  },
  headerEmergencyAirTransportation: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerEmergencyAirTransportation',
    defaultMessage: 'Emergency Air Transportation that was approved by us in advance',
  },
  headerAirfareReturnHome: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerAirfareReturnHome',
    defaultMessage: 'Airfare to Return Home For Treatment Benefit that was approved by us in advance',
  },
  headerFamilyTransportation: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerFamilyTransportation',
    defaultMessage: 'Family Transportation that was approved by us in advance',
  },
  tooltipFamilyTransportation: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipFamilyTransportation',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit or the Airfare to Return Home for treatment benefit.',
  },
  headerMedicalAttendant: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerMedicalAttendant',
    defaultMessage: 'Medical Attendant that was approved by us in advance',
  },

  // Common fields
  displayExpenseBoxIncluding: {
    id: 'fastCover.studentMedicalBenefitsTugo.displayExpenseBoxIncluding',
    defaultMessage: 'Display expense box including:',
  },
  descriptionOfExpense: {
    id: 'fastCover.studentMedicalBenefitsTugo.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpense: {
    id: 'fastCover.studentMedicalBenefitsTugo.dateOfExpense',
    defaultMessage: 'Date of expense',
  },
  amountClaimed: {
    id: 'fastCover.studentMedicalBenefitsTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  providerName: {
    id: 'fastCover.studentMedicalBenefitsTugo.providerName',
    defaultMessage: 'Provider Name',
  },
  providerDetail: {
    id: 'fastCover.studentMedicalBenefitsTugo.providerDetail',
    defaultMessage: 'Provider Detail',
  },
  currency: {
    id: 'fastCover.studentMedicalBenefitsTugo.currency',
    defaultMessage: 'Currency',
  },

  // Common responses
  yes: {
    id: 'fastCover.studentMedicalBenefitsTugo.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.studentMedicalBenefitsTugo.no',
    defaultMessage: 'No',
  },
  isRequired: {
    id: 'fastCover.studentMedicalBenefitsTugo.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.studentMedicalBenefitsTugo.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.studentMedicalBenefitsTugo.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  expenseFor: {
    id: 'fastCover.studentMedicalBenefitsTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.studentMedicalBenefitsTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },

  // Essential Medical Appliances
  checkboxEssentialMedicalAppliances: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxEssentialMedicalAppliances',
    defaultMessage: 'Essential Medical Appliances',
  },
  tooltipEssentialMedicalAppliances: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipEssentialMedicalAppliances',
    defaultMessage: 'Expenses related to the cost of renting essential medical equipment such as crutches or wheelchair.',
  },
  headerEssentialMedicalAppliances: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerEssentialMedicalAppliances',
    defaultMessage: 'Essential Medical Appliances',
  },

  // Private Duty Nursing
  checkboxPrivateDutyNursing: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },
  tooltipPrivateDutyNursing: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipPrivateDutyNursing',
    defaultMessage: 'Private duty nursing must be performed by an RN other than a family member when ordered in writing by the attending physician.',
  },
  headerPrivateDutyNursing: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },

  // Fracture Treatment
  checkboxFractureTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipFractureTreatment',
    defaultMessage: 'Expenses related to fracture treatment including casting, splinting, and related medical procedures.',
  },
  headerFractureTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatmentHeader: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipFractureTreatmentHeader',
    defaultMessage: 'This can include the cost of x-rays, reexamination by a physician, casting, re-casting and cast removal. Fracture benefit does not apply if you have claimed Airfare to Return Home for Treatment.',
  },
  selectInsureds: {
    id: 'fastCover.selectInsureds',
    defaultMessage: 'Select Insured(s)',
  },

  // Maternity Benefits
  checkboxMaternityBenefits: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxMaternityBenefits',
    defaultMessage: 'Maternity Benefits',
  },
  dateOfConception: {
    id: 'fastCover.studentMedicalBenefitsTugo.dateOfConception',
    defaultMessage: 'Please enter the date of conception:',
  },
  dateOfConceptionTooltip: {
    id: 'fastCover.studentMedicalBenefitsTugo.dateOfConceptionTooltip',
    defaultMessage: 'Conception means the date your pregnancy began, not when you discovered you were pregnant',
  },
  anticipatedDueDate: {
    id: 'fastCover.studentMedicalBenefitsTugo.anticipatedDueDate',
    defaultMessage: 'Please enter your anticipated due date:',
  },
  headerRoutinePreNatalCare: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerRoutinePreNatalCare',
    defaultMessage: 'Routine Pre-Natal Care',
  },
  headerComplicationsOfPregnancy: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerComplicationsOfPregnancy',
    defaultMessage: 'Complications of Pregnancy',
  },
  headerInvoluntaryTermination: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerInvoluntaryTermination',
    defaultMessage: 'Involuntary termination',
  },
  otherExpensesRelatedToHospitalization: {
    id: 'fastCover.studentMedicalBenefitsTugo.otherExpensesRelatedToHospitalization',
    defaultMessage: 'Other expenses related to hospitalization',
  },

  // Professional Services
  checkboxProfessionalServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxProfessionalServices',
    defaultMessage: 'Professional Services',
  },
  noteProfessionalServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.noteProfessionalServices',
    defaultMessage: 'These benefits are only eligible when they are ordered by a physician at the time of, and as a result of your emergency.',
  },
  headerPhysiotherapist: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerPhysiotherapist',
    defaultMessage: 'Physiotherapist',
  },
  headerChiropractor: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerChiropractor',
    defaultMessage: 'Chiropractor',
  },
  headerChiropodist: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerChiropodist',
    defaultMessage: 'Chiropodist',
  },
  headerOsteopath: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerOsteopath',
    defaultMessage: 'Osteopath',
  },
  headerPodiatrist: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerPodiatrist',
    defaultMessage: 'Podiatrist',
  },
  headerAcupuncturist: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerAcupuncturist',
    defaultMessage: 'Acupuncturist',
  },
  headerNaturopath: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerNaturopath',
    defaultMessage: 'Naturopath',
  },
  headerSpeechTherapist: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerSpeechTherapist',
    defaultMessage: 'Speech Therapist',
  },
  headerMentalHealthOrSupportPractitioner: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerMentalHealthOrSupportPractitioner',
    defaultMessage: 'Mental Health or Support Practitioner',
  },

  // Rehabilitation Treatment
  checkboxRehabilitationTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxRehabilitationTreatment',
    defaultMessage: 'Rehabilitation Treatment',
  },
  noteRehabilitationTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.noteRehabilitationTreatment',
    defaultMessage: 'Rehab treatment is ordered by a physician after discharge from emergency hospitalization. This must be pre approved by us to be eligible for payment.',
  },
  headerRehabilitationTreatment: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerRehabilitationTreatment',
    defaultMessage: 'Rehabilitation Treatment',
  },

  // Dental Services
  checkboxDentalServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxDentalServices',
    defaultMessage: 'Dental Services',
  },
  headerDentalAccident: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerDentalAccident',
    defaultMessage: 'Dental Accident (result of a blow to the face)',
  },
  headerImpactedWisdomTooth: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerImpactedWisdomTooth',
    defaultMessage: 'Impacted Wisdom Tooth',
  },
  headerDentalPainOther: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerDentalPainOther',
    defaultMessage: 'Dental pain other than accident or wisdom tooth',
  },

  // Prescription Glasses, Contact Lenses or Hearing Aids
  checkboxPrescriptionGlassesContactLensesHearingAids: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxPrescriptionGlassesContactLensesHearingAids',
    defaultMessage: 'Prescription Glasses, Contact Lenses or Hearing Aids',
  },
  tooltipPrescriptionGlassesContactLensesHearingAids: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipPrescriptionGlassesContactLensesHearingAids',
    defaultMessage: 'Coverage is only available for the replacement of, or need for, these items as a result of an accident or injury that happened during your policy period.',
  },
  headerPrescriptionGlassesContactLensesHearingAids: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerPrescriptionGlassesContactLensesHearingAids',
    defaultMessage: 'Prescription Glasses, Contact Lenses or Hearing Aids',
  },

  // Tutorial Services
  checkboxTutorialServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.checkboxTutorialServices',
    defaultMessage: 'Tutorial Services',
  },
  tooltipTutorialServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.tooltipTutorialServices',
    defaultMessage: 'Coverage is only available from a qualified tutorial service and only if you were hospitalized for 30 or more consecutive days.',
  },
  headerTutorialServices: {
    id: 'fastCover.studentMedicalBenefitsTugo.headerTutorialServices',
    defaultMessage: 'Tutorial Services',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StudentMedicalBenefits/messages.js